import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import Select from '../../commonComponents/util/Select';

const initialState = {
    approverId: '',
    submitAttempted: false
};

export default class ApproverReplacementModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    onChange(name, value) {
        this.setState({ [name]: value });
    }

    onContinue() {
        this.setState({ submitAttempted: true });
        if(!this.state.approverId) return;

        this.onClose(this.state.approverId);
    }

    onClose(approverId) {
        this.setState(initialState);
        this.props.close(approverId);
    }

    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal warning-modal">
                        <h4 className="page-header"><i className="material-icons middle">warning</i>Warning</h4>
                        <p className="medium-text">{this.props.user.name} has approval permissions.  <span className="bold-text">Please select a replacement approver before continuing.</span></p>
                        <ValidatedInput input={<Select options={this.props.approvers.filter(approver => approver.key !== this.props.user.userId)} />}
                            name="approverId" value={this.state.approverId}
                            onChange={this.onChange.bind(this)} required={true} showRequiredError={this.state.submitAttempted} />
                        <div className="warning-modal-btns text-right">
                            <button className="btn btn-accent" onClick={() => this.onClose()}>Cancel</button>
                            <button className="btn btn-accent2" onClick={this.onContinue.bind(this)}>Continue</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/settingComponents/userSettings/ApproverReplacementModal.jsx